import { RootState } from '../types';
import { storeResources } from '../resources';
import { IChat, IChatMessage, IPusherConfig, ITechTyping } from '../../services/chats/types';

export const ChatsSelector = (state: RootState): IChat[] => state[storeResources.CHATS].chats;
export const MessagesSelector = (state: RootState): IChatMessage[] =>
  state[storeResources.CHATS].messages;
export const PusherConfigSelector = (state: RootState): IPusherConfig =>
  state[storeResources.CHATS].pusherConfig;
export const ActiveChatSelector = (state: RootState): number =>
  state[storeResources.CHATS].activeChat;

export const ChatSelector = (state: RootState): IChat => state[storeResources.CHATS].chat;
export const ChatsNotifications = (state: RootState): Record<number, number> =>
  state[storeResources.CHATS].notifications ?? {};

export const TechTypingSelector = (state: RootState): ITechTyping =>
  state[storeResources.CHATS].techTyping;
